export default {
  $vuetify: {
    noDataText: "Aucun pays trouvé",

    common: {
      giftcard: "Acheter <br> une carte-cadeau",
      coupons: "Acheter <br> des coupons",
      deposit: "Déposer <br> des fonds",
      close: "Fermer",
      cancel: "Annuler",
      back: "Retour",
      continue: "Continuer",
      confirm: "Confirmer",
      home: "Accueil",
      details: "Détails",
      quantity: "Quantité",
      other: "Autre",
      purchased: "Acheté",
      expires: "Expire",
      includingTax: "(TTC)",
      logout: "Déconnexion",
      orMore: " ou plus",
      submit: "Soumettre",
      tryAgain: "Réessayer",
      success: "Succès",
      info: "Info",
      edit: "Éditer",
      hours: "Heures",
      closed: "Fermé",
      location: "Emplacement",
      contact: "Contact",
      custom: "Personnalisé",
    },

    account: {
      cancel: "Annuler",
      creditCard: "Carte de crédit",
      nameOnCard: "Nom sur la carte",
      cardNumber: "Numéro de carte",
      expires: "Expire",
      cvc: "CVC",
      mmyy: "MM / AA",
      country: "Pays de facturation",
      saveCard: "Enregistrer la carte",
      addPaymentMethod: "Ajouter un moyen de paiement",
      otherPostalCode:
        "Pour les cartes hors US ou Canada, veuillez entrer un numéro quelconque",
    },

    featureSelect: {
      title: "Sélectionnez une des fonctionnalités ci-dessous",
    },

    checkout: {
      title: "Informations de paiement",
      pay: "Payer",
      confirmDeposit: "Confirmer le dépôt",
      confirmPurchase: "Confirmer l'achat",
      reviewYourCart: "Vérifier votre panier",
      choosePaymentOption: "Choisir une option de paiement",
      paymentInformation: "Informations de paiement",
      receipt: "Reçu",
      digitalEGiftCard: "Carte-cadeau électronique",
      subtotal: "Sous-total",
      yourGiftCardDetails: "Détails de la carte-cadeau",
      to: "À",
      from: "De",
      selectPaymentMethod: "Sélectionner un moyen de paiement",
      bonus: "Bonus",
      points: "Points",
      depositDirectlyToAccount: "Votre dépôt sera directement crédité au compte associé au numéro de téléphone fourni, résultant dans un solde mis à jour.",
      receiptEmailSameAsRecipientEmail: "L'e-mail de facturation est le même que l'e-mail du destinataire",
      personalizedMessage: "Message (Facultatif)",
      backToAllGiftDetails: "Retour aux détails de la carte-cadeau",
      depositDetails: "Détails du dépôt",
      depositTo: "Déposer à:",
      addPayment: "Ajouter un paiement"
    },

    confirmation: {
      thankyou: "Merci pour votre achat de carte-cadeau",
      thankyouWithName: "Merci pour votre achat de carte-cadeau, {0}",
      sentto: "Votre carte-cadeau pour {0} a été envoyée à",
      depositSuccess: "Merci pour votre dépôt!",
      newBalance: "Votre solde de dépôt est : ",
      couponPurchase: "Merci pour votre achat de coupon!",
      useFundsDeposit: "Utiliser le dépôt",
      useFundsPurchase: "Utiliser les fonds",
      makeAnotherDeposit: "Faire un autre dépôt",
      makeAnotherPurchase: "Faire un autre achat",
      giftCardValue: "Valeur de la carte-cadeau",
      weveSentTheGiftCardTo: "Nous avons envoyé la carte-cadeau à",
      itShouldArriveShortly: "Elle devrait arriver dans quelques minutes.",
      startAnOrder: "Commencer un commande",
      purchaseAnotherCard: "Acheter une autre carte-cadeau",
      bonus: "Bonus",
      depositSuccessful: "Dépôt réussi",
      addedTo: "Ajouté à",
      depositValue: "Valeur du dépôt",
      deposited: "Déposé",
      creditAddedToMembership: "Crédit ajouté à votre adhésion — disponible maintenant.",
    },

    deposit: {
      card1: {
        title: "Dépôt d'adhésion",
        subtitle: "Choisissez un montant prédéfini ci-dessous.",
        bonusTip: "Les bonus s'appliquent pour les dépôts plus élevés.",
        memberInformation: "Informations de l'adhérent",
        memberInformationSubtitle: "Ce dépôt sera lié à l'adhésion sous ce numéro de mobile. Nous enverrons également un SMS de confirmation.",
      },
      card2: {
        title: "Bonus de dépôt",
        subtitle:
          "Déposez un des montants ci-dessous pour des bonus incroyables!",
        bonusCoupons: "Coupons bonus",
        headers: [
          "Infos",
          "Montant du dépôt",
          "Bonus en espèces",
          "Points bonus",
          "Coupons bonus",
          "Bonus unique",
        ],
        bonusInfo: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> avec {1} dans le dépôt d'adhésion`,
        bonusInfoOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> avec {1} ou plus dans le dépôt d'adhésion`,
        bonusInfoRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> avec {1} - {2} dans le dépôt d'adhésion`,
        bonusInfoPoints: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> avec {1} dans le dépôt d'adhésion`,
        bonusInfoPointsOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> avec {1} ou plus dans le dépôt d'adhésion`,
        bonusInfoPointsRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> avec {1} - {2} dans le dépôt d'adhésion`,
      },
      preset: "Montant du dépôt",
      backToDepositDetail: "Retour aux détails du dépôt",
      backToHome: "Retour à l'accueil",
      checkoutAndDeposit: "Valider et déposer",
    },

    giftcard: {
      title: "Détails de la carte-cadeau",
      defaultMessage: "J'espère que cela vous plaira!",
      sub1: "Votre carte-cadeau peut être envoyée par SMS ou e-mail.",
      sub2: "Veuillez sélectionner une méthode.",
      chooseDesign: "Choisissez la carte-cadeau parfaite",
      chooseDesignSub: "Surprenez quelqu'un de spécial avec une carte-cadeau numérique instantanée par SMS ou e-mail. Parfaite pour toute célébration!",
      reChooseDesign: "Voulez-vous essayer un autre style? Cliquez pour parcourir plus de designs",
      card2: {
        title: "Bonus de carte-cadeau",
        subtitle:
          "Achetez une des cartes-cadeaux ci-dessous pour des bonus incroyables!",
        headers: [
          "Infos",
          "Montant de l'achat",
          "Bonus en espèces",
          "Points bonus",
          "Coupons bonus",
          "Bonus unique",
        ],
      },
      preset: "Montant de l'achat",
      backToAllGiftCards: "Retour à toutes les cartes-cadeaux",
      custom: "Personnalisé",
      currentPromotions: "Promotions actuelles",
      message: "Message(Facultatif)",
      giftCardDesign: "Design de carte-cadeau"
    },

    coupon: {
      title: "Acheter des coupons",
      addToCart: "Ajouter",
      remaining: "Restant",
      noneAvailable: "Aucun coupon n'est disponible à l'achat pour le moment.",
    },

    migrate: {
      login: "Veuillez vous connecter pour migrer votre compte",
      selectOfTwo: "Veuillez entrer une des deux options",
      phoneHint: "Veuillez entrer votre numéro de mobile",
      realFruitLogin: "Veuillez vous connecter pour migrer votre compte",
      enterEmail: "Veuillez fournir l'e-mail de votre compte",
      enterId: "Veuillez entrer votre numéro de carte-cadeau",
      externalId: "Numéro de carte-cadeau",
      giftCard: "Numéro de carte-cadeau",
      externalIdHint: "Le numéro fourni par le service que vous souhaitez migrer",
      giftCardHint: "Votre numéro de carte-cadeau",
      email: "E-mail",
      emailHint: "L'e-mail fourni par le service que vous souhaitez migrer",

      confirmDetails: "Veuillez confirmer vos détails",
      name: "Nom :",
      externalID: "Numéro de carte-cadeau",
      pointsBalance: "Solde de points",
      balance: "Solde",
      tier: "Niveau",

      migrated: "Votre compte a été migré avec succès",
      migrateAgain: "Migrer un autre compte",
    },

    errorReport: {
      main: "Oh non!",
      secondary: "Quelque chose s'est mal passé.",
      invalidWechat: "Veuillez scanner ce QR Code dans l'application Wechat",
    },

    paymentDetails: {
      cardType: "Crédit",
      wechat: "Wechat",
      cardNumber: "Numéro de carte",
      ready: "Détails du paiement prêts",
      accepted: "Paiement accepté",
      inProgress: "Demande d'achat déjà en cours",
      cardDetailsError: "Échec de lecture des détails de la carte de paiement",
      cardDetailsMissing: "Veuillez entrer vos informations de carte",
      completePayment: "Compléter le paiement",
      addTip: "Ajouter un pourboire",
      paymentFailed: "Échec du paiement, veuillez vérifier vos informations et réessayer",

      subtotal: "Sous-total",
      tip: "Pourboire",
      total: "Total",
    },

    wechat: {
      error: "Une erreur est survenue, veuillez réessayer",
      mismatch: "La carte ne correspond pas à celle enregistrée",
    },

    userAcount: {
      accountInfo: "Infos du compte",
      orderHistory: "Historique des commandes",
      paymentMethods: "Moyens de paiement",
    },

    forms: {
      billing: {
        phone: "Numéro de téléphone de facturation",
        sixDigitCode: "Code à 6 chiffres",
        phoneHint: "Entrez votre numéro de téléphone de facturation",
        phoneError: "Veuillez entrer un numéro de téléphone",
        name: "Nom de facturation",
        nameHint: "Nom sur la carte",
        email: "E-mail de facturation",
        emailHint: "Entrez votre e-mail de facturation",
        emailError: "Veuillez entrer une adresse e-mail valide",
      },

      deposit: {
        phone: "Numéro de mobile",
        phoneHint: "Veuillez entrer le numéro de téléphone pour le dépôt",
        enterCustomAmount: "Entrer le montant personnalisé",
      },

      giftcard: {
        phone: "Numéro de téléphone du destinataire",
        recipientMobilePhone: "Numéro de mobile du destinataire",
        phoneHint:
          "Le numéro de téléphone de la personne à qui vous souhaitez envoyer la carte-cadeau",
        phoneError: "Veuillez entrer un numéro de téléphone",
        email: "E-mail du destinataire",
        recipientEmail: "E-mail du destinataire",
        emailHint:
          "L'e-mail de la personne à qui vous souhaitez envoyer la carte-cadeau",
        emailError: "Veuillez entrer un e-mail",
        name: "Votre nom",
        nameHint: "Cela apparaîtra dans le message du destinataire",
        message: "Message (Facultatif)",
        messageHint:
          "Ceci est un message personnalisé à envoyer avec votre carte-cadeau",
        whoAreYouGiftingTo: "À qui vous donnez la carte-cadeau?",
        personalNote: "Note personnelle",
        termsAndConditions: "Conditions d'utilisation",
        checkOutAndSendGift: "Valider et envoyer la carte-cadeau",
        custom: "Personnalisé",
        enterCustomAmount: "Entrer le montant personnalisé",
        giftAmount: "Montant de la carte-cadeau",
        senderName: "Nom de l'expéditeur (facultatif)",
        recipientName: "Nom du destinataire",
        recipientNameHint: "Le nom de la personne à qui vous offrez",
        recipientNameError: "Veuillez entrer un nom de destinataire",
        selectDeliveryMethod: "Veuillez sélectionner une méthode de livraison",
        selectOrEnterAmount: "Sélectionnez ou entrez le montant de la carte-cadeau, montant entier entre {0} - {1}",
        selectAnAmount: "Sélectionnez un montant",
        enterCustomDollarAmount: "Entrer le montant personnalisé en dollars",
      },

      coupon: {
        phone: "Numéro de mobile",
        phoneHint: "Entrez le numéro de téléphone de votre compte",
        couponsError: "Veuillez sélectionner un coupon",
      },

      emptyError: "Veuillez entrer un nom",
      amountPrompt: "Entrer le montant",
      cardPrompt: "Veuillez entrer le montant de la carte",
      amountMax: "Le montant ne peut pas dépasser {0}",
      amountMin: "Le montant doit être d'au moins {0}",

      country: "Pays de facturation",
      otherPostalCode: "Code postal",
      checkout: {
        selectCountry: "Veuillez sélectionner un pays",
        enterPostalCode: "Veuillez entrer votre code postal",
        fillMissingFields: "Veuillez remplir les champs manquants"
      }
    },

    dialog: {
      recipient: "Destinataire",
      mobile: "Mobile",
      amount: "Montant",
      message: "{0} vous a envoyé une carte-cadeau!",
    },
    presetRow: {
      title: "Montant du dépôt",
    },

    lottery: {
      loginTitle: "Connectez-vous pour gagner un prix!",
      noCoupons: "Pas de coupons",
      title: "Tournez pour gagner!",
      spin: "TOURNEZ",
      youWon: "Vous avez gagné!",
      useCoupon: "Utiliser le coupon",
      spinAgain: "Tournez encore",
      goShopping: "Accueil",
      lossText: "Vous n'avez rien gagné, bonne chance la prochaine fois!",
    },

    login: {
      login: "Connexion",
      phoneNumber: "Numéro de téléphone",
      verifyCode: "Code de vérification",
    },
    hours: {
      twentyFourHours: "Ouvert 24h/24",
      midNight: "Minuit",
      mon: "Lun",
      tues: "Mar",
      wed: "Mer",
      thurs: "Jeu",
      fri: "Ven",
      sat: "Sam",
      sun: "Dim",
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
    },

    header: {
      location: 'Emplacements',
      order: 'Commander',
      reservation: 'Réservations',
      lineup: "Liste d'Attente",
      giftcard: 'Cartes Cadeaux',
      coupons: 'Coupons',
      deposit: 'Ajouter des Fonds',
      login: "S'identifier / S'inscrire",
    },
  },
};
